<template>
  <b-container class="font-weight-bold">
    <b-navbar variant="primary" class="d-flex justify-content-center">
      <b-navbar-brand class="text-light font-weight-bold m-0"
        >信用卡捐款</b-navbar-brand
      >
    </b-navbar>
    <div>
      <loading color="#fd7e14" :active.sync="isLoading"></loading>
    </div>
    <p class="mt-3 font-weight-bold text-center">
      {{ data.memberName }}大德您好：<br />
      感謝您的捐款！<br />
      很高興為您服務，我是福智傳心委員{{ data.wumanName }}(編號：{{
        data.wumanNo
      }})。<br />
      以下是您的捐款資訊請確認內容，並請您填寫信用卡資訊
    </p>

    <b-card
      header="捐款資訊"
      header-bg-variant="secondary"
      header-tag="header"
      header-text-variant="light font-weight-bold"
      header-class="text-center"
    >
      <b-row>
        <b-col class="right-text" cols="6">捐款項目：</b-col>
        <b-col class="left-text" cols="6">{{ data.donaUseName }}</b-col>
      </b-row>
      <b-row>
        <b-col class="right-text" cols="6">捐款金額：</b-col>
        <b-col class="left-text" cols="6">{{ data.amountTxn }}元(新台幣)</b-col>
      </b-row>
      <b-row>
        <b-col class="right-text" cols="6">收據開立方式：</b-col>
        <b-col class="left-text" cols="6">{{ data.receiptType }}</b-col>
      </b-row>
      <b-row>
        <b-col class="right-text" cols="6">收據抬頭：</b-col>
        <b-col class="left-text" cols="6">{{ data.donatorName }}</b-col>
      </b-row>
      <b-row>
        <b-col class="right-text" cols="6">電子信箱：</b-col>
        <b-col class="left-text" cols="6">{{ data.email }}</b-col>
      </b-row>
    </b-card>
    <br />
    <b-form @submit="onSubmit" v-if="show">
      <b-card
        header="付款方式"
        header-bg-variant="secondary"
        header-tag="header"
        header-text-variant="light font-weight-bold"
        header-class="text-center"
      >
        <b-row v-if="data.time == 'ONE'">
          <b-col class="right-text" cols="6">捐款類型：</b-col>
          <b-col class="left-text" cols="6">單次捐款</b-col>
        </b-row>
        <div v-if="data.time == 'MORE'">
          <b-row>
            <b-col class="right-text" cols="6">捐款類型：</b-col>
            <b-col class="left-text" cols="6">定期定額捐款</b-col>
          </b-row>
          <div class="p-2 text-center alert-section">
            <b-card-text>
              每 1 個月扣 1 次<br />每月 15 號扣款
              {{ data.amountTxn }} 元(新台幣)
            </b-card-text>
          </div>
        </div>
      </b-card>
      <br />
      <b-card
        header="捐款注意事項"
        header-bg-variant="secondary"
        header-tag="header"
        header-text-variant="light font-weight-bold"
        header-class="text-center"
      >
        <b-form-checkbox
          id="checkbox-1"
          v-model="data.isAcceptPdpa"
          name="checkbox-1"
          value="accept"
          unchecked-value="reject"
          class="text-left pb-4"
          >我同意遵守本網站個人<u>
            <b-link v-b-modal.dona-notice-detail class="font-weight-bold"
              >捐款注意事項</b-link
            > </u
          >及其他有關著作權、版權、商標專用權、網路智慧財產權等之法律規定。
          <b-modal id="dona-notice-detail" title="捐款注意事項" scrollable>
            <p style="text-align: justify;">
              <strong>信用卡的注意事項：</strong>
            </p>
            <p style="text-align: justify;">
              1.
              本次交易採用「藍新金流」機制進行付款，故信用卡交易帳單將顯示為「藍新科技股份有限公司」。
            </p>
            <p style="text-align: justify;">
              2.
              非經持卡人同意，如有冒用他人卡片盜刷之行為，刑法最高判五年有期徒刑。
            </p>
            <p style="text-align: justify;">
              3. 本頁面已使用 SSL 安全加密機制。
            </p>
            <p style="text-align: justify;">
              4.
              為確保網路交易安全，您同意本公司得就此筆交易向發卡銀行、收單銀行及持卡人核對是否屬實。
            </p>
            <p style="text-align: justify;">
              5.
              信用卡成功交易後否認，如經判定為本人或授權刷卡的行為，相關損失及費用須自行負擔。
            </p>
            <p style="text-align: justify;">
              6. 您的捐款，將由「{{
                data.accountName
              }}」開立捐款收據，由福智傳心提供捐款系統與服務。
            </p>
            <p style="text-align: justify;">
              7.
              若有任何問題，請您於週一至週五上班時間早上9:00至下午6:00來電02-7730-0016。
            </p>
            <p style="text-align: justify;">
              本人瞭解已詳閱、知悉上開注意事項，並同意<font
                v-if="data.bankConnectCode != 'BYHEART'"
                >貴會及</font
              >福智傳心(財團法人高雄市橋頭區福智寺)基於贈與契約關係、法定義務及募款等目的，蒐集、處理及利用本人提供之下列個人資料。本人亦瞭解本人得自由選擇是否提供全部或部份個人資料，如拒絕提供或提供不實，可能影響本人之相關權益（包括但不限於收據開立寄送、所得稅扣抵等）。
            </p>
            <template v-slot:modal-footer="{ ok }">
              <b-button size="sm" variant="primary" @click="ok()">
                確定
              </b-button>
            </template>
          </b-modal>
        </b-form-checkbox>
      </b-card>
      <b-row class="mb-5 mt-4 justify-content-center">
        <b-col cols="auto">
          <b-button
            pill
            type="submit"
            variant="primary"
            class="left-btn text-light"
            :disabled="isSubmitDisabled"
            >前往付款</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </b-container>
</template>
<script>
import { isNullOrUndefined } from "util";
import { CheckFunctions } from "../services/CheckFunctions";
class CridCard {
  id;
  number;
  expMonth;
  expYear;
  cvc;
}
export default {
  name: "DonationCardPage",
  data() {
    return {
      // api url 版本網址
      url: "creditCard/v12/",
      data: {
        uuid: null,
        wumanNo: "",
        wumanName: "",
        memberNo: "",
        memberName: "",
        donaUseName: "",
        amountTxn: "",
        receiptType: "",
        donatorName: "",
        email: "",
        time: "ONE", //ONE or MORE
        isAcceptPdpa: false,
        cardList: [],
        bankConnectCode: "",
        accountName: "",
      },
      isLoading: false,
      show: false,
      monthList: [],
      yearList: [],
      cardNum1: "",
    };
  },
  async created() {
    this.isLoading = true;
    let uuid = this.$route.query.uuid;
    let status = this.$route.query.status;
    console.info("uuid:" + JSON.stringify(this.$route.query.uuid));
    if (isNullOrUndefined(uuid)) {
      this.show = false;
      this.isLoading = false;
      this.$root.errorMessage = "查無此頁";
      this.$router.replace({ name: "ERROR" });
      return;
    }

    // 特別處理 藍新 MPG 交易成功不做任何事，增加等待時間
    if (status === "SUCCESS" && status !== undefined) {
      // 強制等 2 秒
      await this.wait(2000);
    }

    this.$http
      .get(`${this.url}open?uuid=${uuid}`)
      .then((res) => {
        let body = res.body;
        if (body.status == 200) {
          this.data = body.data;
          this.$nextTick(() => {
            this.data.cardList = [];
            this.data.isAcceptPdpa = this.data.isAcceptPdpa
              ? "reject"
              : "accept";
            this.show = true;
            this.isLoading = false;
          });
        } else {
          this.show = false;
          this.isLoading = false;
          let message = "提示";
          if (body.message != undefined) {
            message = body.message;
          }
          switch (body.pageChange) {
            case "NEXT":
              this.$nextTick(() => {
                this.$root.errorMessage = message;
                this.$router.replace({ name: "ERROR" });
              });
              break;
            case "NONE":
              let t = "提示";
              let c = "";
              if (body.message.includes(":")) {
                t = body.message.split(":")[0];
                c = body.message.split(":")[1];
              } else {
                c = body.message;
              }
              this.$dialog.alert(
                {
                  title: t,
                  body: c,
                },
                { html: true, okText: "好" }
              );
              break;
            default:
              this.$nextTick(() => {
                this.$root.errorMessage = message;
                this.$router.replace({ name: "ERROR" });
              });
              break;
          }
        }
      })
      .catch((e) => {
        this.$nextTick(() => {
          this.show = false;
          this.isLoading = false;
          this.$root.errorMessage = "讀取失敗";
          this.$router.replace({ name: "ERROR" });
        });
      });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      this.data.isAcceptPdpa =
        this.data.isAcceptPdpa == "accept" ? true : false;

      // // TODO: test
      // console.log("onSubmit:" + JSON.stringify(this.data));
      // return;
      this.$http
        .post(`${this.url}swipe`, this.data, {
          "Content-Type": "application/json",
        })
        .then((res) => {
          console.log(JSON.stringify(res));
          this.isLoading = false;
          let body = res.body;
          if ((body.status = 200 && body.message == "成功取得MPG HTML")) {
            var body2 = body.data;
            document.body.innerHTML = body2;
            document.forms[0].submit();
          } else {
            switch (body.pageChange) {
              case "NEXT":
                this.$nextTick(() => {
                  this.$root.errorMessage = body.message;
                  this.$router.replace({ name: "ERROR" });
                });
                break;
              case "NONE":
                let t = "提示";
                let c = "";
                if (body.message.includes(":")) {
                  t = body.message.split(":")[0];
                  c = body.message.split(":")[1];
                } else {
                  c = body.message;
                }
                this.$dialog.alert(
                  {
                    title: t,
                    body: c,
                  },
                  { html: true, okText: "好" }
                );
                //設定回預設打勾
                this.data.isAcceptPdpa = "accept";
                break;
              case "CANBACK":
                console.log("CANBACK");
                this.$nextTick(() => {
                  this.$root.errorMessage = body.message;
                  this.$router.replace({
                    name: "ERROR",
                    query: { page: "CARD", uuid: this.data.uuid },
                  });
                });
                break;
              default:
                this.$nextTick(() => {
                  this.$root.errorMessage = body.message;
                  this.$router.replace({ name: "ERROR" });
                });
                break;
            }
          }
        })
        .catch((e) => {
          this.$nextTick(() => {
            this.show = false;
            this.isLoading = false;
            this.$root.errorMessage = "讀取失敗";
            this.$router.replace({ name: "ERROR" });
          });
        });
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  computed: {
    isSubmitDisabled() {
      if (this.data.isAcceptPdpa != "accept") {
        console.log("no ok isAcceptPdpa:" + this.data.isAcceptPdpa);
        return true;
      }
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.left-btn {
  margin-right: 8px;
}
.right-btn {
  margin-left: 8px;
}
.address-input {
  margin-bottom: 3px;
}
.text-required {
  color: red !important;
}
.alert-section {
  background-color: #fdfcf5;
  border: 1px solid transparent;
  border-color: #faebcc;
  border-radius: 4px;
}
.header {
  background-color: rgb(182, 158, 22);
  line-height: 40px;
  color: azure;
  padding-left: 10px;
  font-weight: 700;
  font-size: 20px;
}
.content {
}
.right-text {
  text-align: right;
}
.left-text {
  text-align: left;
}
.text-height-center {
  line-height: 37px;
}

.small-col {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.line {
  display: inline-block;
}

.card-number {
  border: 0;
}
</style>
